import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/svg/free-proxy-list.svg'


const _withScopeId = n => (_pushScopeId("data-v-3e7ac6ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-lg-4 col-md-6 col-12" }
const _hoisted_2 = { class: "itemcard downloadcard" }
const _hoisted_3 = ["href"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "HTTP Proxies", -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Last updated: ")
const _hoisted_8 = { id: "httplastupdated" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = { id: "httpproxyamount" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" proxies ")
const _hoisted_12 = { class: "selectors" }
const _hoisted_13 = { for: "httptimeoutslide" }
const _hoisted_14 = {
  class: "nice-select selectortypes",
  tabindex: "0"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Country: "),
  /*#__PURE__*/_createElementVNode("span", { class: "current" }, "all")
], -1))
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<li data-value=\"all\" class=\"option\" data-v-3e7ac6ca>all</li><li data-value=\"DE\" class=\"option\" data-v-3e7ac6ca>DE</li><li data-value=\"US\" class=\"option\" data-v-3e7ac6ca>US</li><li data-value=\"ID\" class=\"option\" data-v-3e7ac6ca>ID</li><li data-value=\"KH\" class=\"option\" data-v-3e7ac6ca>KH</li><li data-value=\"CN\" class=\"option\" data-v-3e7ac6ca>CN</li><li data-value=\"NG\" class=\"option\" data-v-3e7ac6ca>NG</li><li data-value=\"BD\" class=\"option\" data-v-3e7ac6ca>BD</li><li data-value=\"MX\" class=\"option\" data-v-3e7ac6ca>MX</li><li data-value=\"RU\" class=\"option\" data-v-3e7ac6ca>RU</li><li data-value=\"IN\" class=\"option\" data-v-3e7ac6ca>IN</li><li data-value=\"CO\" class=\"option\" data-v-3e7ac6ca>CO</li><li data-value=\"AR\" class=\"option\" data-v-3e7ac6ca>AR</li><li data-value=\"BR\" class=\"option\" data-v-3e7ac6ca>BR</li><li data-value=\"SG\" class=\"option\" data-v-3e7ac6ca>SG</li><li data-value=\"FR\" class=\"option\" data-v-3e7ac6ca>FR</li><li data-value=\"TR\" class=\"option\" data-v-3e7ac6ca>TR</li><li data-value=\"UZ\" class=\"option\" data-v-3e7ac6ca>UZ</li><li data-value=\"EG\" class=\"option\" data-v-3e7ac6ca>EG</li><li data-value=\"GB\" class=\"option\" data-v-3e7ac6ca>GB</li><li data-value=\"EC\" class=\"option\" data-v-3e7ac6ca>EC</li><li data-value=\"TH\" class=\"option\" data-v-3e7ac6ca>TH</li><li data-value=\"UA\" class=\"option\" data-v-3e7ac6ca>UA</li><li data-value=\"NP\" class=\"option\" data-v-3e7ac6ca>NP</li>", 24)
const _hoisted_40 = [
  _hoisted_16
]
const _hoisted_41 = {
  class: "nice-select selectortypes",
  tabindex: "0"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Anonymity: "),
  /*#__PURE__*/_createElementVNode("span", { class: "current" }, "all")
], -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", {
  "data-value": "all",
  class: "option selected"
}, "all", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", {
  "data-value": "elite",
  class: "option"
}, "elite", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", {
  "data-value": "anonymous",
  class: "option"
}, "anonymous", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", {
  "data-value": "transparent",
  class: "option"
}, "transparent", -1))
const _hoisted_47 = [
  _hoisted_43,
  _hoisted_44,
  _hoisted_45,
  _hoisted_46
]
const _hoisted_48 = {
  class: "nice-select selectortypes",
  tabindex: "0"
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("SSL: "),
  /*#__PURE__*/_createElementVNode("span", { class: "current" }, "all")
], -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", {
  "data-value": "all",
  class: "option selected"
}, "all", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", {
  "data-value": "yes",
  class: "option"
}, "yes", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", {
  "data-value": "no",
  class: "option"
}, "no", -1))
const _hoisted_53 = [
  _hoisted_50,
  _hoisted_51,
  _hoisted_52
]
const _hoisted_54 = { class: "downloadbtn" }
const _hoisted_55 = ["href"]
const _hoisted_56 = /*#__PURE__*/_createTextVNode(" or ")
const _hoisted_57 = ["href"]

import { httpState } from '@/composables/free-proxies';
import FreeProxies from '@/services/api/fproxy-service';
import nProgress from 'nprogress';
import { onUnmounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

/* eslint-disable @typescript-eslint/no-explicit-any */
const url = 'https://api.proxyscrape.com/v2/';
const proxyInfo = async () => {
  const proxyInf = await FreeProxies.proxyInfoHttp();
  httpState.proxy_info.proxy_count = proxyInf.data.proxy_count;
  httpState.proxy_info.last_updated = proxyInf.data.last_updated;
};
proxyInfo();

const onTimeout = () => {
  proxyInfo();
};
const getCountry = (click: any) => {
  httpState.country = click.target.outerText;
  proxyInfo();
};

const getSSL = (click: any) => {
  httpState.ssl = click.target.outerText;
  proxyInfo();
};

const getAnonymity = (click: any) => {
  httpState.anonymity = click.target.outerText;
  proxyInfo();
};
const onDownload = () => {
  nProgress.start();
  setTimeout(() => {
    setTimeout(() => nProgress.done(), 400);
  }, 300);
};

onUnmounted(() => {
  httpState.getproxies = 'getproxies';
  httpState.type = 'http';
  httpState.timeout = 10000;
  httpState.country = 'all';
  httpState.anonymity = 'all';
  httpState.ssl = 'all';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        href: `${url}?request=getproxies&protocol=http&timeout=${_unref(httpState).timeout}&country=${_unref(httpState).country}&ssl=${_unref(httpState).ssl}&anonymity=${_unref(httpState).anonymity}`,
        onClick: onDownload
      }, _hoisted_6, 8, _hoisted_3),
      _createElementVNode("p", null, [
        _hoisted_7,
        _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(httpState).proxy_info.last_updated), 1),
        _hoisted_9,
        _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(httpState).proxy_info.proxy_count), 1),
        _hoisted_11
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("label", _hoisted_13, "Timeout: " + _toDisplayString(_unref(httpState).timeout) + " ms", 1),
        _withDirectives(_createElementVNode("input", {
          type: "range",
          step: "50",
          min: "50",
          max: "10000",
          class: "slider",
          onClick: onTimeout,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(httpState).timeout) = $event))
        }, null, 512), [
          [_vModelText, _unref(httpState).timeout]
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("ul", {
            class: "list httpcountry countryselect",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (getCountry($event)))
          }, _hoisted_40)
        ]),
        _createElementVNode("div", _hoisted_41, [
          _hoisted_42,
          _createElementVNode("ul", {
            class: "list httpanonimity",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (getAnonymity($event)))
          }, _hoisted_47)
        ]),
        _createElementVNode("div", _hoisted_48, [
          _hoisted_49,
          _createElementVNode("ul", {
            class: "list httpssl",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (getSSL($event)))
          }, _hoisted_53)
        ])
      ]),
      _createElementVNode("div", _hoisted_54, [
        _createElementVNode("a", {
          href: `${url}?request=getproxies&protocol=http&timeout=${_unref(httpState).timeout}&country=${_unref(httpState).country}&ssl=${_unref(httpState).ssl}&anonymity=${_unref(httpState).anonymity}`,
          style: {"cursor":"pointer"},
          class: "save-btn",
          onClick: onDownload
        }, "Download", 8, _hoisted_55),
        _hoisted_56,
        _createElementVNode("a", {
          href: `${url}?request=share&protocol=http&timeout=${_unref(httpState).timeout}&country=${_unref(httpState).country}&ssl=${_unref(httpState).ssl}&anonymity=${_unref(httpState).anonymity}`,
          style: {"cursor":"pointer"}
        }, "Share", 8, _hoisted_57)
      ])
    ])
  ]))
}
}

})